import { nullable, struct } from 'io-ts/Decoder';

import { ComplexId } from '../../../folder/ComplexId';

export const Request = struct({
	parentFolderId: nullable(ComplexId),
});
